export const TimeZone = {
  None: 0,
  Hawaii: 1,
  Alaska: 2,
  Pacific: 3,
  Mountain: 4,
  Central: 5,
  Eastern: 6,
}

export const TimeZoneDatabaseNames = {
  [TimeZone.Hawaii]: 'Pacific/Honolulu',
  [TimeZone.Alaska]: 'America/Anchorage',
  [TimeZone.Pacific]: 'America/Los_Angeles',
  [TimeZone.Mountain]: 'America/Boise',
  [TimeZone.Central]: 'America/Chicago',
  [TimeZone.Eastern]: 'America/New_York',
}

export const TimeZoneOptions = [
  { label: 'Hawaii', value: 1 },
  { label: 'Alaska', value: 2 },
  { label: 'Pacific', value: 3 },
  { label: 'Mountain', value: 4 },
  { label: 'Central', value: 5 },
  { label: 'Eastern', value: 6 },
]

export const normalizedTimeZone = {
  1: 'Hawaii',
  2: 'Alaska',
  3: 'Pacific',
  4: 'Mountain',
  5: 'Central',
  6: 'Eastern',
}

export const TimezoneId = {
  1: 'HST',
  2: 'AST',
  3: 'PST',
  4: 'MST',
  5: 'CST',
  6: 'EST',
}
